<section class="panel widget-container navigator-panel" [class.mojo-admin-page]="isInDashboardMode">
  <a alt="Preview" (click)="tileClick()">
    <header class="panel-heading">
      <h5 class="panel-title">Preview</h5>
    </header>
    <div class="ui-g navigator-panel-body">

      <div class="ui-g-6 navigator-panel-text">
        Review dashboard layouts with live data for a particular client or client parent record
      </div>
      <div class="ui-g-6 navigator-panel-icon">
        <i class="fa fa-eye"></i>
      </div>

    </div>
  </a>
</section>
<mojo-mci-preview-mode-dialog-container #mciPreviewer></mojo-mci-preview-mode-dialog-container>
